'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.CHYBA = exports.POZASTAVEN = exports.NEZTOTOZNEN = exports.ZTOTOZNEN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Stav ztotožnění subjektu vůči základním regstrům.
 */

/**
 * Ztotožněn.
 */
var ZTOTOZNEN = exports.ZTOTOZNEN = 'ZTOTOZNEN';

/**
 * Neztotožněn.
 */
var NEZTOTOZNEN = exports.NEZTOTOZNEN = 'NEZTOTOZNEN';

/**
 * Pozastaven.
 */
var POZASTAVEN = exports.POZASTAVEN = 'POZASTAVEN';

/**
 * Chyba ISZR při ztotožnění.
 */
var CHYBA = exports.CHYBA = 'CHYBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ZTOTOZNEN, NEZTOTOZNEN, POZASTAVEN, CHYBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ZTOTOZNEN, { caption: 'Ztotožněn.' }), (0, _defineProperty3.default)(_params, NEZTOTOZNEN, { caption: 'Neztotožněn.' }), (0, _defineProperty3.default)(_params, POZASTAVEN, { caption: 'Pozastaven.' }), (0, _defineProperty3.default)(_params, CHYBA, { caption: 'Chyba ISZR při ztotožnění.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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